import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../../hooks/useAuth.js";
import styles from "./Layout.module.css";

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <button
          className={styles.hamburger}
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Toggle menu"
        >
          ☰
        </button>
        <Link to="/" className={styles.logo}>
          QA Monitor
        </Link>
        <div className={styles.userMenu}>
          <span className={styles.email}>{user?.email}</span>
          <button className={styles.logoutBtn} onClick={handleLogout}>
            Logout
          </button>
        </div>
      </header>

      <div className={styles.body}>
        <nav className={`${styles.sidebar} ${sidebarOpen ? styles.sidebarOpen : ""}`}>
          <NavLink to="/" end className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ""}`}>
            📊 Dashboard
          </NavLink>
          <NavLink to="/projects" className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ""}`}>
            📁 Projects
          </NavLink>
          <NavLink to="/profiles" className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ""}`}>
            ⚙ Profiles
          </NavLink>
        </nav>
        {sidebarOpen && (
          <div className={styles.overlay} onClick={() => setSidebarOpen(false)} />
        )}
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  );
}
